import LandingPageForm from '../components/LandingPageForm';

export default function ArcadiaLandingPage() {
  return (
    <LandingPageForm 
      cityName="Arcadia"
      neighborhood="Arcadia"
      sourceTag="qr-arcadia-mailer"
    />
  );
}
